// extracted by mini-css-extract-plugin
export default {"bannerStart":"Banner_bannerStart__XSAkI","header":"Banner_header__6xNFp","text":"Banner_text__seJkH","image":"Banner_image__xDf7v"};